/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FailedAuthorizationOAuthAppsSpec } from './failedAuthorizationOAuthAppsSpec';
import { AuthorizationOAuthAppsSpec } from './authorizationOAuthAppsSpec';


export interface OAuthAppCredentialsMigrationStatus { 
    already_in_admin_count?: number;
    already_in_admin_details?: Array<AuthorizationOAuthAppsSpec>;
    failed_count?: number;
    failed_details?: Array<FailedAuthorizationOAuthAppsSpec>;
    migrated_successfully_count?: number;
    migrated_successfully_details?: Array<AuthorizationOAuthAppsSpec>;
    migration_completed?: boolean;
    oauth_apps_count?: number;
    org_id?: string;
}

